export const basePromotionCities: {id: number; slug: string; name: string}[] = [
    {id: 8647, slug: "warszawa", name: "Warszawa"},
    {id: 11158, slug: "krakow", name: "Kraków"},
    {id: 26955, slug: "wroclaw", name: "Wrocław"},
    {id: 30892, slug: "poznan", name: "Poznań"},
    {id: 46083, slug: "gdansk", name: "Gdańsk"},
    {id: 16187, slug: "lodz", name: "Łódź"},
    {id: 31600, slug: "katowice", name: "Katowice"},
    {id: 13220, slug: "lublin", name: "Lublin"},
    {id: 22550, slug: "bydgoszcz", name: "Bydgoszcz"},
    {id: 19894, slug: "torun", name: "Toruń"},
    {id: 6196, slug: "gdynia", name: "Gdynia"},
    {id: 33659, slug: "rzeszow", name: "Rzeszów"},
    {id: 36190, slug: "kielce", name: "Kielce"},
    {id: 26804, slug: "olsztyn", name: "Olsztyn"}
];
export const basePromotionCities: {id: number; slug: string; name: string}[] = [
    {id: 8647, slug: "warszawa", name: "Warszawa"},
    {id: 11158, slug: "krakow", name: "Kraków"},
    {id: 26955, slug: "wroclaw", name: "Wrocław"},
    {id: 30892, slug: "poznan", name: "Poznań"},
    {id: 46083, slug: "gdansk", name: "Gdańsk"},
    {id: 16187, slug: "lodz", name: "Łódź"},
    {id: 31600, slug: "katowice", name: "Katowice"},
    {id: 13220, slug: "lublin", name: "Lublin"},
    {id: 22550, slug: "bydgoszcz", name: "Bydgoszcz"},
    {id: 19894, slug: "torun", name: "Toruń"},
    {id: 6196, slug: "gdynia", name: "Gdynia"},
    {id: 33659, slug: "rzeszow", name: "Rzeszów"},
    {id: 36190, slug: "kielce", name: "Kielce"},
    {id: 26804, slug: "olsztyn", name: "Olsztyn"}
];
